import styled from 'styled-components';
import factoryButton from './utils/factoryButton';
import BaseBtnSC from './styles/BaseBtnSC';
const ButtonText = styled(BaseBtnSC) `
  color: ${(props) => props.theme.ColorFontButtonTextBase};

  &._ndsBtn--grey {
    color: ${(props) => props.theme.ColorFontButtonTextGrey};
  }

  &._ndsBtn--destructive {
    color: ${(props) => props.theme.ColorFontButtonTextError};
  }

  & > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonTextBase};
  }

  &._ndsBtn--grey > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonTextGrey};
  }

  &._ndsBtn--destructive > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonTextError};
  }

  :hover {
    background-color: ${(props) => props.theme.ColorBackgroundButtonTextHover};
  }

  &._ndsBtn--grey:hover {
    background-color: ${(props) => props.theme.ColorBackgroundButtonTextGreyHover};
  }

  &._ndsBtn--destructive:hover {
    background-color: ${(props) => props.theme.ColorBackgroundButtonTextErrorHover};
  }

  &._ndsBtn--grey:disabled,
  &._ndsBtn--destructive:disabled,
  :disabled {
    background-color: transparent;
    color: ${(props) => props.theme.ColorFontButtonTextDisabled};
  }

  &._ndsBtn--loading:disabled {
    background-color: ${(props) => props.theme.ColorBackgroundButtonTextLoading};
    color: ${(props) => props.theme.ColorFontButtonTextLoading};
  }

  &._ndsBtn--grey._ndsBtn--loading:disabled {
    background-color: ${(props) => props.theme.ColorBackgroundButtonTextGreyLoading};
    color: ${(props) => props.theme.ColorFontButtonTextGreyLoading};
  }

  &._ndsBtn--destructive._ndsBtn--loading:disabled {
    background-color: ${(props) => props.theme.ColorBackgroundButtonTextErrorLoading};
    color: ${(props) => props.theme.ColorFontButtonTextErrorLoading};
  }

  :disabled > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonTextDisabled};
  }
`;
export default factoryButton(ButtonText);
//# sourceMappingURL=ButtonText.js.map